import InstantConnect from './InstantConnect'

export default InstantConnect
